import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Ibuprofen() {
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [cartCount, setCartCount] = useState(0);
  const [selectedPackage, setSelectedPackage] = useState('50pills');

  useEffect(() => {
    const updateCartCount = () => {
      const savedCart = localStorage.getItem('cart');
      if (savedCart) {
        const cart = JSON.parse(savedCart);
        const count = cart.reduce((sum: number, item: any) => sum + item.quantity, 0);
        setCartCount(count);
      }
    };
    
    updateCartCount();
  }, []);

  const product = {
    id: 3,
    name: 'Ibuprofen 400mg',
    category: 'Pain Relief',
    price: 8.99,
    originalPrice: 12.99,
    images: [
      'https://public.readdy.ai/ai/img_res/4a0869c20afe666128918bd7955c551c.jpg',
      'https://readdy.ai/api/search-image?query=ibuprofen%20400mg%20tablets%20blister%20pack%20detailed%20view%20professional%20pharmaceutical%20photography%20clean%20background&width=600&height=600&seq=302&orientation=squarish',
      'https://readdy.ai/api/search-image?query=ibuprofen%20pain%20medication%20bottle%20with%20label%20professional%20pharmaceutical%20packaging%20photography%20clean%20white%20background&width=600&height=600&seq=303&orientation=squarish'
    ],
    rating: 4.7,
    reviewCount: 289,
    inStock: true,
    stockCount: 78,
    description: 'Ibuprofen is a nonsteroidal anti-inflammatory drug (NSAID) used to reduce fever and treat pain or inflammation caused by many conditions such as headache, toothache, back pain, arthritis, menstrual cramps, or minor injury.',
    dosage: 'Take 400mg every 4-6 hours as needed. Do not exceed 1200mg in 24 hours unless directed by a doctor.',
    sideEffects: 'May cause stomach upset, heartburn, dizziness, or headache. Take with food or milk to reduce stomach irritation.',
    contraindications: 'Do not use if you have a history of stomach ulcers, kidney problems, or are allergic to NSAIDs. Avoid during late pregnancy.',
    manufacturer: 'Pfizer',
    activeIngredient: 'Ibuprofen 400mg',
    prescriptionRequired: false
  };

  const addToCart = () => {
    const savedCart = localStorage.getItem('cart');
    const cart = savedCart ? JSON.parse(savedCart) : [];
    
    const existingItem = cart.find((item: any) => item.id === product.id);
    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      cart.push({
        id: product.id,
        name: product.name,
        category: product.category,
        price: product.price,
        image: product.images[0],
        quantity: quantity,
        prescriptionRequired: product.prescriptionRequired
      });
    }
    
    localStorage.setItem('cart', JSON.stringify(cart));
    setCartCount(cart.reduce((sum: number, item: any) => sum + item.quantity, 0));
    navigate('/cart');
  };

  const addToWishlist = () => {
    const savedWishlist = localStorage.getItem('wishlist');
    const wishlist = savedWishlist ? JSON.parse(savedWishlist) : [];
    
    const exists = wishlist.find((item: any) => item.id === product.id);
    if (!exists) {
      wishlist.push({
        id: product.id,
        name: product.name,
        category: product.category,
        price: product.price,
        image: product.images[0]
      });
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      setShowWishlistNotification(true);
      setTimeout(() => setShowWishlistNotification(false), 3000);
    }
  };

  const shareProduct = (platform: string) => {
    const url = window.location.href;
    const text = `Check out ${product.name} on MediCare`;
    
    switch(platform) {
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_blank');
        break;
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'copy':
        navigator.clipboard.writeText(url).catch(err => {
          console.error('Failed to copy link: ', err);
          alert('Failed to copy link. Please copy manually.');
        });
        break;
    }
    setShowShareMenu(false);
  };

  return (
    <div className="min-h-screen bg-white">
      {showWishlistNotification && (
        <div className="fixed top-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 flex items-center space-x-2">
          <i className="ri-heart-fill"></i>
          <span>Added to wishlist!</span>
        </div>
      )}

      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-2xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>MediCare</Link>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Home</Link>
              <a href="/#categories" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Categories</a>
              <a href="/#products" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Products</a>
              <a href="#about" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">About</a>
              <a href="#contact" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Contact</a>
            </div>
            <div className="flex items-center space-x-4">
              <button className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                <i className="ri-search-line text-xl"></i>
              </button>
              <Link to="/cart" className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer relative">
                <i className="ri-shopping-cart-line text-xl"></i>
                <span className="absolute -top-1 -right-1 bg-teal-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{cartCount}</span>
              </Link>
              <Link to="/auth" className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                <i className="ri-user-line text-xl"></i>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <nav className="flex text-sm text-gray-500">
          <Link to="/" className="hover:text-teal-600 cursor-pointer">Home</Link>
          <span className="mx-2">/</span>
          <span className="hover:text-teal-600 cursor-pointer">{product.category}</span>
          <span className="mx-2">/</span>
          <span className="text-gray-900">{product.name}</span>
        </nav>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <div className="mb-4">
              <img 
                src={product.images[selectedImage]} 
                alt={product.name} 
                className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
              />
            </div>
            <div className="grid grid-cols-3 gap-4">
              {product.images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`${product.name} ${index + 1}`}
                  className={`h-24 object-cover object-top rounded-lg cursor-pointer border-2 ${
                    selectedImage === index ? 'border-teal-600' : 'border-gray-200'
                  } hover:border-teal-400 transition-colors`}
                  onClick={() => setSelectedImage(index)}
                />
              ))}
            </div>
          </div>

          <div>
            <div className="mb-4">
              <span className="text-sm text-teal-600 font-semibold">{product.category}</span>
              <h1 className="text-3xl font-bold text-gray-900 mt-2">{product.name}</h1>
            </div>

            <div className="flex items-center mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`${
                      i < Math.floor(product.rating) ? 'ri-star-fill' : 'ri-star-line'
                    } text-yellow-400 text-lg`}
                  ></i>
                ))}
              </div>
              <span className="ml-2 text-gray-600">({product.reviewCount} reviews)</span>
            </div>

            <div className="mb-6">
              <div className="flex items-center space-x-4">
                <span className="text-3xl font-bold text-gray-900">${product.price}</span>
                {product.originalPrice && (
                  <span className="text-xl text-gray-500 line-through">${product.originalPrice}</span>
                )}
              </div>
              {product.inStock ? (
                <p className="text-green-600 font-semibold mt-2">
                  <i className="ri-checkbox-circle-line mr-1"></i>
                  In Stock ({product.stockCount} available)
                </p>
              ) : (
                <p className="text-red-600 font-semibold mt-2">
                  <i className="ri-close-circle-line mr-1"></i>
                  Out of Stock
                </p>
              )}
            </div>

            {!product.prescriptionRequired && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                <div className="flex items-center">
                  <i className="ri-checkbox-circle-line text-green-600 text-lg mr-2"></i>
                  <span className="text-green-800 font-semibold">No Prescription Required</span>
                </div>
                <p className="text-green-700 text-sm mt-1">This medication is available over-the-counter.</p>
              </div>
            )}

            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">Quantity</label>
              <div className="flex items-center space-x-4">
                <div className="flex items-center border border-gray-300 rounded-lg">
                  <button 
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
                  >
                    <i className="ri-subtract-line"></i>
                  </button>
                  <span className="w-12 text-center font-semibold">{quantity}</span>
                  <button 
                    onClick={() => setQuantity(Math.min(product.stockCount, quantity + 1))}
                    className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
                  >
                    <i className="ri-add-line"></i>
                  </button>
                </div>
                <button 
                  onClick={addToCart}
                  className="flex-1 bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer font-semibold"
                >
                  <i className="ri-shopping-cart-line mr-2"></i>
                  Add to Cart - ${(product.price * quantity).toFixed(2)}
                </button>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <button 
                onClick={addToWishlist}
                className="border-2 border-teal-600 text-teal-600 px-6 py-3 rounded-lg hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer font-semibold"
              >
                <i className="ri-heart-line mr-2"></i>
                Add to Wishlist
              </button>
              <div className="relative">
                <button 
                  onClick={() => setShowShareMenu(!showShareMenu)}
                  className="w-full border-2 border-gray-300 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer font-semibold"
                >
                  <i className="ri-share-line mr-2"></i>
                  Share Product
                </button>
                {showShareMenu && (
                  <div className="absolute top-full mt-2 right-0 bg-white border border-gray-200 rounded-lg shadow-lg p-2 z-10 w-48">
                    <button 
                      onClick={() => shareProduct('facebook')}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded flex items-center space-x-2 cursor-pointer"
                    >
                      <i className="ri-facebook-fill text-blue-600"></i>
                      <span>Facebook</span>
                    </button>
                    <button 
                      onClick={() => shareProduct('twitter')}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded flex items-center space-x-2 cursor-pointer"
                    >
                      <i className="ri-twitter-fill text-blue-400"></i>
                      <span>Twitter</span>
                    </button>
                    <button 
                      onClick={() => shareProduct('whatsapp')}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded flex items-center space-x-2 cursor-pointer"
                    >
                      <i className="ri-whatsapp-fill text-green-600"></i>
                      <span>WhatsApp</span>
                    </button>
                    <button 
                      onClick={() => shareProduct('copy')}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded flex items-center space-x-2 cursor-pointer"
                    >
                      <i className="ri-file-copy-line text-gray-600"></i>
                      <span>Copy Link</span>
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="border-t pt-6">
              <p className="text-sm text-gray-600"><strong>SKU:</strong> MED{product.id.toString().padStart(6, '0')}</p>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg-gray-900 text-gray-300 py-12 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Pacifico", serif' }}>MediCare</h3>
              <p className="text-gray-400 mb-4">Your trusted partner in healthcare, delivering quality medicines to your doorstep.</p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:text-teal-400 transition-colors cursor-pointer">Home</Link></li>
                <li><a href="#about" className="hover:text-teal-400 transition-colors cursor-pointer">About Us</a></li>
                <li><a href="#contact" className="hover:text-teal-400 transition-colors cursor-pointer">Contact</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Categories</h4>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Weight Loss</a></li>
                <li><a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Antibiotics</a></li>
                <li><a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Pain Relief</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Contact Info</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-phone-line mt-1 mr-2"></i>
                  <span>+1 (555) 123-4567</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-mail-line mt-1 mr-2"></i>
                  <span>support@medicare.com</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-400">&copy; 2024 MediCare. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-teal-400 transition-colors cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
